
<spinner *ngIf="loading"></spinner>

<div class="card">
    <div class="card-header">
        My patients
    </div>
    <div class="card-body">

        <form class="d-flex justify-content-between" [formGroup]="filterForm">
            <div class="row g-2">
                <div class="form-group col">
                    <label class="form-label">Study</label>
                    <ng-select [multiple]="true" placeholder="Select 1+ options" formControlName="study">
                        <ng-option value="">Select item</ng-option>
                    </ng-select>
                </div>
                <div class="form-group col">
                    <label class="form-label">Site</label>
                    <ng-select [multiple]="true" placeholder="Select 1+ options" formControlName="site">
                        <ng-option value="">Select item</ng-option>
                    </ng-select>
                </div>
                <div class="form-group col">
                    <label class="form-label">Status</label>
                    <ng-select [multiple]="true" placeholder="Select 1+ options" formControlName="status">
                        <ng-option value="">Select item</ng-option>
                    </ng-select>
                </div>
                <div class="form-group col">
                    <label class="form-label">Last name</label>
                    <input type="text" class="form-control" formControlName="lastName" placeholder="Enter last name" />
                </div>
                <div class="form-group col">
                    <label class="form-label">Participant code</label>
                    <input type="text" class="form-control" formControlName="participantCode" placeholder="Enter code" />
                </div>
                <div class="form-group col">
                    <label class="form-label">Includes demo</label>
                    <ng-select [multiple]="false" [clearable]="false" formControlName="includesDemo">
                        <ng-option value="0">No</ng-option>
                        <ng-option value="1">Yes</ng-option>
                    </ng-select>
                </div>
                <div class="col-auto d-flex align-items-end flex-row-reverse pb-1">
                    <button type="submit" class="btn btn-success px-3" (click)="filter()">
                        <i class="bi bi-search"></i>
                    </button>
                </div>
                <div class="col d-flex align-items-end pb-1">
                    <a type="reset" class="btn btn-link px-3" (click)="reset()">Clear filters</a>
                </div>
            </div>
        </form>

        <hr>

        <ngx-datatable class="bootstrap" #table
                       [rows]="rows"
                       [columnMode]="'force'"
                       [headerHeight]="50"
                       [externalPaging]="true"
                       [externalSorting]="true"
                       [footerHeight]="30"
                       [rowHeight]="'auto'"
                       [limit]="page.size"
                       [count]="page.totalCount"
                       [offset]="offset"
                       (page)="setPage($event)"
                       [messages]="{emptyMessage: 'No results found', totalMessage: 'records found'}"
                       (sort)="sort($event)"
        >
            <ngx-datatable-column prop="participantName" name="PATIENT" [sortable]="true" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.name }} <br>
                    {{ row.code }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="participantCode" name="STATUS" [sortable]="true" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    Needs attention
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="studyCode" name="WEIGHT" [sortable]="true" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.weight }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="site" name="BMI" [sortable]="true" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="badge text-bg-danger">{{ row.bmi }}</span>

                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="site" name="TYPE" [sortable]="true" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    Patient
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="site" name="PLAN" [sortable]="true" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.plan }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="actions" name="ACTIONS" [sortable]="false" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a [routerLink]="['/demo/patient-overview']">
                        <i class="bi bi-caret-right-fill text-gray" style="font-size:1.7em"></i>
                    </a>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>

    </div>
</div>

